module.exports = __webpack_public_path__ + "static/img/noAddress.f37f3ea0.png";